import { Component, OnInit } from '@angular/core';
import { AllLinksComponent } from 'src/app/core/all-links/all-links.component';
import { LearnerService } from 'src/app/core/services/learner.service';
import { DocumentPreviewService } from 'src/app/core/services/document-preview.service';
import { LoginService } from 'src/app/core/login/login.service';
import { Router,ActivatedRoute } from '@angular/router';
import { SidebarService } from 'src/app/core/services/sidebar.service';

@Component({
  selector: 'app-guidelines-policy',
  templateUrl: './guidelines-policy.component.html',
  styleUrls: ['./guidelines-policy.component.css']
})
export class GuidelinesPolicyComponent implements OnInit {

  form: any;
  data: any;
  isAdmin: boolean = false;
  user: any;
  name: any;
  user_type: any;
  lndUserType: boolean = false;
  AllLinksComponent: any;
  documents: any = [];
  type:string='policy';
  sidebarCollapsed: boolean = false;
  constructor(
    public allLink: AllLinksComponent,
    private learnerService: LearnerService,
    private documentPreview: DocumentPreviewService,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private sidebarService: SidebarService
  ) { 

  }

  ngOnInit(): void {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    this.learnerService.getUserType().subscribe(res => {
      this.user = res['lnd_user_type'];
      this.lndUserType = true;
      localStorage.setItem('user_type', res['lnd_user_type']);
    },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == 'Signature has expired') {
          this.loginService.logout();
        }
      });
    // this.user_type = localStorage.getItem('user_type');
    this.isAdmin = localStorage.getItem('user_type') == 'admin' ? true : false;
    // this.user = localStorage.getItem('user_type');
    this.name = localStorage.getItem('name');
    this.learnerService.getDocumentsList(this.type).subscribe(res => {
      console.log(res);
      this.documents = res;

    },
      (error: any) => {
        console.log(error, error.error, error.message);
      });
  }

  
  viewDownloadPdf(file: string, fileName: string) {
    this.documentPreview.preview(file, fileName, 'Guidelines & Policy');
  }
  home() {
    this.router.navigate(['home']);
  }

}
